<template>
  <v-container grid-list-xl class="pa-5" v-if="presensi">
    <m-breadcrum :items="bread"></m-breadcrum>
    <m-card
      select
      filter-grup
      filter-aktivasi
      style="position:relative"
      :title="
        periode && periode.nama
          ? 'Detail Persentase Kehadiran Periode ' + periode.nama
          : 'Detail Persentase Bulanan'
      "
      @filter="onFilter"
    >
      <div class="text-right" v-if="presensi.length > 0 && isCan('tenant-laporan.download-persentase')">
        <m-button
          color="success"
          icon="mdi-download"
          text="Unduh Laporan"
          action="exportXls"
          @exportXls="cetakLaporan"
          >Unduh Rekap</m-button
        >
      </div>
      <br />
      <table ref="table" id="rekap" v-if="presensi.length > 0">
        <thead>
          <tr>
            <th rowspan="4">No</th>
            <th rowspan="4">Nama</th>
            <th rowspan="4">NIP</th>
            <th :colspan="kategoriKetidakhadiran.length * 2">
              Tingkat Ketidakhadiran Berdasarkan Rumus Skor
            </th>
            <th rowspan="4" width="10">Jumlah (%)</th>
            <th rowspan="4">Tingkat Kehadiran (%)</th>
          </tr>
          <tr>
            <th
              v-for="kategori in kategoriKetidakhadiran"
              :key="kategori.index"
              colspan="2"
              width="10"
            >
              {{ kategori.nama }}
            </th>
          </tr>
          <tr>
            <th
              v-for="kategori in kategoriKetidakhadiran"
              :key="kategori.index"
              colspan="2"
            >
              {{ kategori.satuan }}
            </th>
          </tr>
          <tr class="font-weight-bold">
            <template v-for="kategori in kategoriKetidakhadiran">
              <th :key="kategori.index">
                {{ kategori.skor }}
              </th>
              <th :key="kategori.id">%</th></template
            >
          </tr>
          <!-- <tr class="font-weight-bold text-center">
              <td v-for="i in 17" :key="i">{{ i }}</td>
            </tr> -->
        </thead>
        <tbody>
          <tr v-for="(item, index) in presensi" :key="item.index">
            <td class="text-center">{{ index + 1 }}</td>
            <td>{{ getDeepObj(item, 'users.nama') || getDeepObj(item, 'nama') || '-'  }}</td>
            <td>{{ getDeepObj(item, 'users.no_pegawai') || getDeepObj(item, 'no_pegawai') || '-' }}</td>
            <template v-for="itemTerlambat in item.rekap.skor">
              <td
                class="text-center"
                :key="`${itemTerlambat.id}` + item.id + Math.random()"
              >
                {{ itemTerlambat.skor_total }}
              </td>
              <td
                class="text-center"
                :key="`${itemTerlambat.id}` + item.nama + Math.random()"
              >
                {{ itemTerlambat.persen }}
              </td>
            </template>
            <td class="text-center">
              {{ item.rekap.jumlah[0].jumlah }}
              <!-- {{ totalPresentaseKeterlambatan(item.itemTerlambatHadir) }} -->
            </td>
            <td class="text-center">
              {{ item.rekap.jumlah[0].tingkat_presensi.toFixed(2) }}

              <!-- {{
                  100 - totalPresentaseKeterlambatan(item.itemTerlambatHadir)
                }} -->
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="text-center">
        <img src="https://cdn.siap.id/s3/asset%20illustrasi/Illustrasi/aset_halaman-kosong.png">
        <h3 class="py-2 black--text">Data Rekap Kehadiran tidak tersedia</h3>
        <p class="body-2 grey--text">Anda dapat melakukan proses perbarui ulang untuk memerika ketersediaan data</p>
      </div>
    </m-card>
  </v-container>
</template>

<script>
import XLSX from "xlsx";
export default {
  components: {},
  data: () => ({
    kehadiran: {},
    periode: [],
    presensi: [],
    kategoriKetidakhadiran: [],
    statusGenerate: false,
    textHint: null,
    user: null,
    show: false,
    page: null,
    cp: 1,
    filters: {},
    headers: [
      { text: "Nama", align: "left", value: "nama" },
      { text: "Hadir", align: "center", value: "hadir" },
      { text: "Ketidakhadiran", align: "center", value: "cuti" },
      { text: "Alpa", align: "center", value: "absen" },
      { text: "Persentase Kehadiran", align: "center", value: "persentase" }
    ]
  }),
  activated() {
    this.load();
    this.loadPeriode();
  },
  methods: {
    exportXls(type, fn, dl) {
      let columns = [];
      for (let i = 5; i <= this.presensi.length + 4; i++) {
        columns.push(`C${i}`);
      }

      var elt = document.getElementById("rekap");
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Persentase Bulanan" });
      if (wb) {
        const names = wb["SheetNames"];
        names.forEach(name => {
          const sheets = wb["Sheets"][name] || {};
          let index = 0;
          Object.keys(sheets).forEach(key => {
            if (columns.includes(key)) {
              wb["Sheets"][name][key]["t"] = "x";
              wb["Sheets"][name][key]["v"] =
                this.presensi[index]["users"]["no_pegawai"] || "";
              index++;
            }
          });
        });
      }

      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn || "Laporan Rekap Presensi Bulanan." + (type || "xlsx")
          );
    },
    load() {
      this.$store
        .dispatch("laporan/detilRekap", {
          organisasi_id: this.organisasi_id,
          params: Object.assign({},  {
            page: this.cp,
            order_by_nama: 1,
            periode_laporan_id: this.periode_laporan_id,
          }, this.filters)
        })
        .then(res => {
          this.presensi = res.data;
          this.kategoriKetidakhadiran = res.data[0].skor_presensi;
        })
        .catch(e => e);
    },
    loadPeriode() {
      this.$store
        .dispatch("periode/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            is_generate: 1
          }
        })
        .then(res => {
          const data = res.data.data || [];
          this.periode =
            data.find(
              s =>
                Number(s.periode_laporan_id) === Number(this.periode_laporan_id)
            ) || {};
        })
        .catch(e => e);
    },
    countLostTimeCategori(value, percent) {
      return (((value * percent) / 100) * 100).toFixed(1);
    },
    totalPresentaseKeterlambatan(item) {
      var totalPercent = 0;
      item.forEach(i => {
        totalPercent = totalPercent + i.presentase * i.jumlah;
      });
      return totalPercent;
    },
    onFilter(data) {
      if (data && data.grup) {
        this.$set(this.filters, 'group_id', data.grup)
      } else {
        this.$delete(this.filters, 'group_id')
      }

      if (![undefined, '', null].includes(data.statusAktivasi)) {
        this.$set(this.filters, 'is_aktif', data.statusAktivasi)
      } else {
        this.$delete(this.filters, 'is_aktif')
      }

      this.load()
    },
    cetakLaporan() {
      const payload = {
        organisasi_id: this.organisasi_id,
        type: 'orgs',
        name: 'presensi/cetak/persentase',
        params: {
          periode_laporan_id: this.periode_laporan_id,
          tgl_awal: this.periode.tgl_mulai,
          tgl_akhir: this.periode.tgl_selesai
        }
      };

      this.$store.dispatch("laporan/cetakLaporan", payload).then(url => {
        window.open(url, "_blank");
      });
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-file",
          title: "Presentase Bulanan",
          to: {
            name: "laporan.kehadiran",
            params: { organisasi_id: this.organisasi_id }
          }
        },
        {
          icon: "mdi-clock",
          title:
            this.periode && this.periode.nama
              ? "Periode " + this.periode.nama || ""
              : ""
        }
      ];
    }
  }
};
</script>
<style>
#rekap {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#rekap td,
#rekap th {
  border: 1px solid #ddd;
  padding: 8px;
}

#rekap tr:nth-child(even) {
  background-color: #f2f2f2;
}

#rekap tr:hover {
  background-color: #ddd;
}

#rekap th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #7f79d9;
  color: white;
}
</style>
